import { dataServiceReducerKey } from '../reducers';
import { promosReducerKey } from './reducer';

export const getRetailerPromos = state => state[dataServiceReducerKey][promosReducerKey].retailerPromos;
